<template>
    <div class="col-12 col-md-10">
        <div class="w-100 d-flex align-items-center mb-5">
            <div class="col-3 text-left"><h5 class="text-left">{{ 'Quantity' | trans }}:</h5></div>
            <div class="col-9">
                <SelectConversionMinutes :disabled="false"></SelectConversionMinutes>
            </div>
        </div>
        <br />
        <div class="col-3 d-md-none"><h5>{{ 'Plan' | trans }}:</h5></div>
        <div class="w-100 d-flex">
            <div class="col-3 d-none d-md-flex"><h5>{{ 'Plan' | trans }}:</h5></div>
            <div class="col-12 col-md-9 d-md-flex flex-md-row justify-content-md-between">
                <div class="col-12 col-md-5 mb-4 md-mb-0">
                    <div class="bg-white p-3">
                        <div>
                            <div class="mb-3 text-uppercase fw-bold"><strong>{{ 'package' | trans }}</strong></div>
                            <div v-if="this.productPriceString" class="mb-2 fw-bold">
                                <strong>{{ this.productPriceString }}</strong>
                            </div>
                            <div class="mb-3 text-secondary fw-lighter" v-if="this.productPriceString">
                                <small>= {{ this.unitPrice }} {{ this.currencySymbol }} {{ 'per Credit' | trans }}</small>
                            </div>
                        </div>
                        <span v-if="!this.productPriceString" class="w-100 d-flex justify-content-center mb-4">
                            <span class="spin-circle-basic spin-circle-225 spin-circle-medium"></span>
                        </span>
                        <div>
                            <button @click.stop.prevent="goToChoosePayment" class="btn btn-primary w-100">{{ 'Buy' | trans }}</button>
                        </div>
                    </div>
                    <div>
                        <small class="fw-lighter" v-html="packageText"></small>
                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <div class="bg-white p-3">
                        <div>
                            <div class="mb-3 text-uppercase fw-bold"><strong>{{ 'subscription' | trans }}</strong></div>
                            <div class="mb-2 fw-bold"><strong>00,00</strong></div>
                            <div class="mb-3 text-secondary fw-lighter"><small>=0,000 $ {{ 'per Credit' | trans }}</small></div>
                        </div>
                        <div>
                            <button disabled class="btn btn-primary w-100">{{ 'Coming Soon' | trans }}</button>
                        </div>
                    </div>
                    <div>
                        <small class="fw-lighter" v-html="subscriptionText"></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SelectConversionMinutes from '../../../../lib-sat/user/modal/register_payment_flow/components/SelectConversionMinutes.vue';
import { pageStoreMixin } from '../../../../lib-sat/store/page-store';
import TransFilter from './mixins/TransFilter.vue';
import DataStatus from './mixins/DataStatus';
import { paymentManager } from '../../../../lib-sat/payment/payment-manager';
import { testIsNonEmptyString } from '../../../../lib/test-and-assert/test-base';
import { paymentApi } from '../../../../lib-sat/payment/payment-api';
import { userModalRoute } from '../../../../lib-sat/user/modal/register_payment_flow/router';
import { globalLogger } from '../../../helper/global-logger';
import { registerPaymentModalHelper } from '../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';
import { translate } from '../../../helper/translate';

export default {
    name: 'BuyPackageAndSubscription',
    components: { SelectConversionMinutes },
    mixins: [TransFilter, DataStatus, pageStoreMixin],
    created() {
        if (paymentManager.isPricingInfoInitialized()) {
            this.initializeData();
            this.setStatusDone();
            return;
        }
        this.initializeData();
    },
    async mounted() {
        await this.getInitialPrice();
    },
    computed: {
        selectedProduct() {
            return this.store.userPaymentModal.selectedProduct;
        },
        selectedSize() {
            return this.store.userPaymentModal.selectedSize;
        },
        selectedProvider() {
            return this.store.userPaymentModal.selectedProvider;
        },
        selectedBilling() {
            return this.store.userPaymentModal.selectedBilling;
        },
        currency() {
            return this.store.userPaymentModal.currency;
        },
        currencySymbol() {
            if (this.currency === 'usd') {
                return '$';
            } else if (this.currency === 'eur') {
                return '€';
            } else {
                return '$hg';
            }
        },
        productSlug() {
            /** @type {PaymentData} */
            const paymentData = {};
            paymentData.billing = this.selectedBilling;
            paymentData.product = this.selectedSize;
            paymentData.provider = this.selectedProvider;

            return paymentManager.getSlugHelper().getSlug(paymentData, this.currency);
        },

        productPriceString() {
            if (!paymentManager.getSlugHelper().getPriceStringFromSlug(this.productSlug)) {
                return this.initialPrice;
            } else {
                return paymentManager.getSlugHelper().getPriceStringFromSlug(this.productSlug);
            }
        },
        unitPrice() {
            let unformattedPrice;
            if (this.currency === 'eur') {
                unformattedPrice = this.productPriceString.slice(0, -1);
            } else {
                unformattedPrice = this.productPriceString.slice(0, -3).slice(1);
            }
            return parseFloat(unformattedPrice) / parseFloat(this.selectedSize);
        },
    },
    methods: {
        initializeData() {
            if (!testIsNonEmptyString(this.selectedProvider)) {
                this.store.userPaymentModal.setSelectedProvider('stripe');
            }
            if (!testIsNonEmptyString(this.selectedSize)) {
                this.store.userPaymentModal.setSelectedSize('500');
            }
            if (!testIsNonEmptyString(this.selectedBilling)) {
                this.store.userPaymentModal.setSelectedBilling('day');
            }
            return;
        },

        async getInitialPrice() {
            if (!paymentManager.isPricingInfoInitialized()) {
                const pricingInformation = await paymentApi.getPricingInformation(true);
                paymentManager.setConfigFromPricingInformation(pricingInformation);
            }

            this.initialPrice = await paymentManager.getSlugHelper().getPriceStringFromSlug(`cm_500_${this.currency}`);
        },
        goToChoosePayment() {
            globalLogger.log('user modal - product selected - ' + this.productSlug);
            registerPaymentModalHelper.openOnPage(userModalRoute.REGISTER_CHOOSE_PAYMENT);
        },
    },
    data() {
        return {
            initialPrice: '',
            userModalRoute: userModalRoute,
            packageText: translate('<strong>Packages</strong> are <strong>one time</strong> payments and your quota will <strong>not expire.</strong> You can buy any amount of Credits and use them whenever you like ("Pay As You Go").'),
            subscriptionText: translate('<strong>Subscriptions</strong> charge you every month for fixed amount of Credits. Not used Credits <strong>do not roll over</strong> at the end of the month. In exchange they are up to 50% cheaper than packages.')
        };
    },
};
</script>
